import { useCallback } from 'react';

import {
  DEFAULT_SUGGEST_IMPROVEMENT,
  GENERATE_USING_OPTIONS,
  MANUAL_SUGGEST_IMPROVEMENT,
} from '../../../const';
import { useLocalActions } from '../store';

export const usePrepareGeneratedUsing = () => {
  const localActions = useLocalActions();

  return useCallback(() => {
    const selectedInstructionsOption = localActions.getSelectedInstructionsOption();

    if (!selectedInstructionsOption) {
      return undefined;
    }

    if (selectedInstructionsOption === DEFAULT_SUGGEST_IMPROVEMENT) {
      return GENERATE_USING_OPTIONS.defaultSuggestion;
    }

    if (selectedInstructionsOption === MANUAL_SUGGEST_IMPROVEMENT) {
      return GENERATE_USING_OPTIONS.manualInstructions;
    }

    return undefined;
  }, [localActions]);
};
